// extracted by mini-css-extract-plugin
export var progressBar = "_if-0";
export var progressBarInner = "_if-1";